var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "self-procurement-register" },
    [
      _c("div", { staticClass: "form-wrap" }, [
        _c("div", { staticClass: "seach" }, [
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-date-picker", {
                attrs: {
                  "time-arrow-control": true,
                  type: "daterange",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "—",
                  "start-placeholder": "添加时间始",
                  "end-placeholder": "添加时间止",
                },
                model: {
                  value: _vm.add_at,
                  callback: function ($$v) {
                    _vm.add_at = $$v
                  },
                  expression: "add_at",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-date-picker", {
                attrs: {
                  "time-arrow-control": true,
                  type: "daterange",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "—",
                  "start-placeholder": "扣款时间始",
                  "end-placeholder": "扣款时间止",
                },
                model: {
                  value: _vm.deduction_at,
                  callback: function ($$v) {
                    _vm.deduction_at = $$v
                  },
                  expression: "deduction_at",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入添加人", clearable: "" },
                model: {
                  value: _vm.formData.owner_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "owner_name", $$v)
                  },
                  expression: "formData.owner_name",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入货号", clearable: "" },
                model: {
                  value: _vm.formData.sku_code,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sku_code", $$v)
                  },
                  expression: "formData.sku_code",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "选择审核状态" },
                  model: {
                    value: _vm.formData.state,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "state", $$v)
                    },
                    expression: "formData.state",
                  },
                },
                _vm._l(_vm.stateList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入审核人", clearable: "" },
                model: {
                  value: _vm.formData.operate_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "operate_name", $$v)
                  },
                  expression: "formData.operate_name",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入备注", clearable: "" },
                model: {
                  value: _vm.formData.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "remarks", $$v)
                  },
                  expression: "formData.remarks",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "问题原因" },
                  model: {
                    value: _vm.formData.qc_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "qc_type", $$v)
                    },
                    expression: "formData.qc_type",
                  },
                },
                _vm._l(_vm.typeList, function (tItem, tIndex) {
                  return _c("el-option", {
                    key: tIndex,
                    attrs: { label: tItem.val, value: tItem.index },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-button", {
                staticClass: "refresh",
                attrs: { type: "primary", icon: "el-icon-refresh" },
                on: { click: _vm.onHandleRefresh },
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.onSearch },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "warning",
                    icon: "el-icon-download",
                    disabled: !_vm.tableData.length || _vm.disabledExport,
                  },
                  on: { click: _vm.exportHandle },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c("table-list", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { tableData: _vm.tableData, is_audit: _vm.is_audit },
            on: {
              openEditGoods: _vm.openEditGoods,
              onHandleShow: _vm.onHandleShow,
              onsubmitRefresh: _vm.onsubmitRefresh,
              openCancelRemark: _vm.openCancelRemark,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.formData.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("edit-goods", {
        ref: "editGoodsRef",
        on: { onsubmitRefresh: _vm.onsubmitRefresh },
      }),
      _c("c-preview-file", {
        attrs: {
          fileList: _vm.fileList,
          fileIndex: _vm.previewIndex,
          fileType: _vm.fileType,
        },
        model: {
          value: _vm.dialogVisible,
          callback: function ($$v) {
            _vm.dialogVisible = $$v
          },
          expression: "dialogVisible",
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: " ",
            visible: _vm.tipShow,
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipShow = $event
            },
          },
        },
        [
          _c("span", [_vm._v(" 您是否确认作废此条记录？ ")]),
          _c(
            "div",
            [
              _c("div", { staticClass: "mt-10 mb-10" }, [_vm._v("备注:")]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 4 },
                  placeholder: "请输入备注",
                  maxlength: "200",
                },
                model: {
                  value: _vm.remark,
                  callback: function ($$v) {
                    _vm.remark = $$v
                  },
                  expression: "remark",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sureHandle } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }